import React, { Component } from 'react'
import { VzPageContainer } from '../../layouts/VzPageContainer'
export default class OrderStatusReport extends Component {
  render() {
    return (
      <div>
        <VzPageContainer title='Order Status Report'>


         
        </VzPageContainer>
      </div>
    )
  }
}
